// material
import { styled } from '@material-ui/core/styles';
// components
import Page from '../components/Page';
import 
  LandingHeroo
 from '../components/_external-pages/admin/Ledger.js';
import { DataGrid } from '@material-ui/data-grid';
import DataGridDemo from 'components/_external-pages/admin/Dashboard';
import BasicTable from 'components/_external-pages/admin/Dashboard';
import BasicCard from 'components/_external-pages/admin/navbar';
import DashboardLayout from 'layouts/dashboard';
import ManageCourts from 'components/_external-pages/admin/ManageCourts';
import DashboardNavbar from 'layouts/dashboard/DashboardNavbar';
import DashboardSidebar from 'layouts/dashboard/DashboardSidebar';
import RefundManagement from 'components/_external-pages/admin/RefundManagement';
// import DataGrid from '../components/_external-pages/admin/Dashboard';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)({
  height: '100%'
});

const ContentStyle = styled('div')(({ theme }) => ({
  overflow: 'hidden',
  position: 'relative',
  backgroundColor: theme.palette.background.default
}));

// ----------------------------------------------------------------------

export default function ManageCourtPage() {
  return (
    <RootStyle title="Admin" id="move_top">
      <DashboardNavbar />
      <DashboardSidebar />
      <RefundManagement />
    </RootStyle>
  );
}
